export function get_label(id, lang, labels) {
	let l = labels.filter((l) => {
		return l.id === id;
	});
	if (l.length > 0) return l[0][lang];
}
